import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'

/* sbr design-system styling for react-select (global — applies to every select) */
const colorStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderRadius: 10,
    borderColor: state.isFocused ? '#2563EB' : '#E9ECF3',
    boxShadow: state.isFocused ? '0 0 0 3px #EFF4FF' : '0 1px 2px rgba(16,24,40,.05)',
    fontSize: 13.5,
    backgroundColor: '#fff',
    transition: 'border-color .14s, box-shadow .14s',
    '&:hover': { borderColor: state.isFocused ? '#2563EB' : '#DCE7FF' },
  }),
  valueContainer: base => ({ ...base, padding: '2px 10px' }),
  placeholder: base => ({ ...base, fontSize: 13.5, color: '#9AA4B2', fontWeight: 500 }),
  singleValue: base => ({ ...base, color: '#0B1424', fontWeight: 600, fontSize: 13.5 }),
  input: base => ({ ...base, color: '#0B1424' }),
  indicatorSeparator: base => ({ ...base, backgroundColor: '#E9ECF3' }),
  dropdownIndicator: (base, state) => ({ ...base, color: state.isFocused ? '#2563EB' : '#9AA4B2', ':hover': { color: '#2563EB' } }),
  clearIndicator: base => ({ ...base, color: '#9AA4B2', ':hover': { color: '#DC2626' } }),
  menu: base => ({ ...base, borderRadius: 12, overflow: 'hidden', border: '1px solid #E9ECF3', boxShadow: '0 12px 30px -8px rgba(16,24,40,.18)', zIndex: 40 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: 13.5,
    fontWeight: 600,
    padding: '9px 12px',
    color: state.isSelected ? '#fff' : '#1C2536',
    backgroundColor: state.isSelected ? '#2563EB' : state.isFocused ? '#EFF4FF' : '#fff',
    cursor: 'pointer',
    ':active': { backgroundColor: state.isSelected ? '#2563EB' : '#DCE7FF' },
  }),
  multiValue: base => ({ ...base, backgroundColor: '#EFF4FF', borderRadius: 7, border: '1px solid #DCE7FF' }),
  multiValueLabel: base => ({ ...base, color: '#1B43C4', fontWeight: 700, fontSize: 12 }),
  multiValueRemove: base => ({ ...base, color: '#1B43C4', borderRadius: '0 7px 7px 0', ':hover': { backgroundColor: '#DC2626', color: '#fff' } }),
}

/* `compact`: for narrow columns. Placeholder and value stay on one line (with an
   ellipsis) so the select keeps the same height as the text inputs beside it. */
const oneLine = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
const compactStyles = {
  ...colorStyles,
  valueContainer: base => ({ ...colorStyles.valueContainer(base), padding: '2px 8px', flexWrap: 'nowrap' }),
  placeholder: base => ({ ...colorStyles.placeholder(base), ...oneLine, fontSize: 12.5 }),
  singleValue: base => ({ ...colorStyles.singleValue(base), ...oneLine, fontSize: 13 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base, state) => ({ ...colorStyles.dropdownIndicator(base, state), padding: '8px 8px 8px 2px' }),
}

const FormSelect = ({label, required, value, isMulti, compact, ...rest}) => {
  return (
    <Form.Group>
        {label && <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label> }
        <div style={{position:"relative"}}>
            { required &&
            <input 
                className="select-required" 
                type="text" 
                value={isMulti ? (value[0] ?? '') : (value ?? '')} 
                onChange={()=>{}}
                tabIndex={-1}
                required={required}
                z-index="-1"
            />
            }
            <Select value={value} isMulti={isMulti} 
            styles={compact ? compactStyles : colorStyles}
            {...rest}/>
        </div>
    </Form.Group>
  )
}

export default FormSelect
